import { render } from "./FieldsEdit.vue?vue&type=template&id=de766500&scoped=true"
import script from "./FieldsEdit.vue?vue&type=script&lang=js"
export * from "./FieldsEdit.vue?vue&type=script&lang=js"

import "./FieldsEdit.vue?vue&type=style&index=0&id=de766500&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de766500"]])

export default __exports__